unable to read source [project]/repos/src/scraping/products/utils.ts